import React, { useRef } from 'react';
import styles from '../styles/partnerServices.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import CustomImage from "./CustomImage";
import Link from 'next/link';
import Card from 'react-bootstrap/Card';
import Recognition from './Recognition';
import FeaturedBlogs from './FeaturedBlogs';
import Testimonial from './Testimonial';
import TopTieUpsOfKC from './UniTieUp';
import KcNewLatestUpdates from './kcNewlatestupdates';
import FeaturedPartnerWebinars from './FeaturedPartnerWebinars';
import FaqComponent from './PST/FrequentlyAskedQuestions';
import VideoTestimonials from './PST/VideoTestimonials';
import CfAppBanner from './CfAppBanner/CfAppBanner';
import Slider from 'react-slick';
import { sliderSpeed } from '../utils/constants';
import { isFrappeOrJotFormClass } from '../utils/helpers';

const ServicesForPartnerPage: React.FC = (props: any) => {
  const sliderRef = useRef<Slider>(null);
  const sliderSettings = {
    dots: true,
    dotsClass: styles.sliderDots,
    className: "slider variable-width",
    infinite: true,
    speed: sliderSpeed.desktopSpeed,
    variableWidth: true,
    centerMode: true,
    initialSlide:0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3.5,
          infinite: true,
          dots: true,
        }
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 2,
          variableWidth: false,
          centerMode: false,
          dots: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          variableWidth: false,
          centerMode: false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          infinite: true,
          dots: false,
          speed: sliderSpeed.mobileSpeed,
          centerMode: false,
        }
      }
    ]
  };
  return (
    <div id='servi-for-partner' className={styles.partner}>
      <div className={styles.curve}>
        <div className={`${styles.contentDiv} ${styles.breadcrum}`}>
          <Container>
            <Row>
              <Col xs={12} lg={6}>
                <div className='d-block d-sm-none'>
                  <Breadcrumb className={styles.mobileBreadCrum}>
                    <Breadcrumb.Item style={{ opacity: 0.5 }} href='/'>
                      Services
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href=''>For Partners</Breadcrumb.Item>
                  </Breadcrumb>
                  <CustomImage
                    src={
                      props.pageData.mainImageUrl ||
                      '/images/partners/partner1.svg'
                    }
                    alt={props.pageData.mainImageAltTag}
                    width={375}
                    height={424}
                  />
                </div>
                <div className={styles.servContent}>
                  <Breadcrumb className='d-none d-sm-block'>
                    <Breadcrumb.Item href='/' style={{ opacity: 0.5 }}>
                      Services
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href=''>For Partners</Breadcrumb.Item>
                  </Breadcrumb>
                  <h1>{props?.pageData?.title}</h1>
                  <p>{props?.pageData?.description}</p>
                  <div className={styles.buttons}>
                    <a
                      className={`${styles.CourseFinder} ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0]?.jotformid)}`}
                    >
                      Partner With Us
                    </a>
                    <a
                      className={`${styles.Callback
                        } ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[1]?.jotformid)}`}
                    >
                      Enquire Now
                    </a>
                  </div>
                </div>
              </Col>
              <Col xs={12} lg={6}>
                <div className='d-none d-sm-block text-center'>
                  <CustomImage
                    src={
                      props.pageData.mainImageUrl ||
                      '/images/partners/partner1.svg'
                    }
                    alt={props.pageData.mainImageAltTag}
                    width={513}
                    height={424}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <div className={styles.WhyKc}>
        <Container>
          <div className={styles.customContainer}>
            <Row>
              <div className='text-center'>
                <h2>Why Partner with KC Overseas?</h2>
              </div>
            </Row>
            <Row>
              {props?.pageData?.whyKc?.length > 0 &&
                props?.pageData?.whyKc.map((kcBenefit: any) => {
                  return (
                    <Col xl={4} md={4} xs={12}>
                      <div className='text-center mb-3'>
                        <div className={styles.circle}>
                        <CustomImage
                            src={kcBenefit?.imagePath}
                            alt={kcBenefit?.ImageAltTag}
                            width={40}
                            height={40}
                          />
                        </div>
                        <h6>{kcBenefit?.title}</h6>
                        <p>{kcBenefit?.description}</p>
                        {/* <a className={styles.viewMore}>Know More</a> */}
                      </div>
                    </Col>
                  );
                })}
            </Row>
          </div>
        </Container>
      </div>

      <div className={styles.countryFlags}>
         <Container>
          <Row className='text-center'>
            <h2>{props?.pageData?.countryFlag?.title}</h2>
            <p>{props?.pageData?.countryFlag?.shortDescription}</p>
          </Row>
         </Container>
      </div>
      <div className={styles.countryFlagSlider}>
      <Slider {...sliderSettings} ref={sliderRef}>
          {props?.pageData?.countryFlag?.flags?.length > 0 &&
            props?.pageData?.countryFlag?.flags.map((image: any, index: number) => {
              return (
                <>
                  {image?.url && image.url.trim() ? (
                      <a href={image.url} target='_blank'>
                        <div className={styles.sliderDiv}  key={index}>
                          <CustomImage
                            src={image?.imagePathUrl}
                            alt={image?.imageAltTag}
                            width={232}
                            height={116}
                            objectFit='contain'
                          />
                        </div>
                      </a>
                    ) : (
                      <div className={styles.sliderDiv} key={index} style={{ cursor: 'default' }}>
                        <CustomImage
                          src={image?.imagePathUrl}
                          alt={image?.imageAltTag}
                          width={232}
                          height={116}
                          objectFit='contain'
                        />
                      </div>
                    )}
                  <p>{image.name}</p>
                </>
              )
            })
          }
        </Slider>
        <div className={styles.arrowsClass}>
              <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickPrev()}>
                <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
              </div>
              <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickNext()}>
                <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
              </div>
            </div>
        </div>

      {/* Technological Capabilities */}
      <div className={styles.TechCapabilities}>
        <Container>
          <div className={styles.customContainer}>
            <Row className='text-center'>
              <h2>Technological Capabilities</h2>
            </Row>
            <Row>
              {/* desktop view */}
                    <div className={styles.CourseFinder}>
                      {/* Course Finder */}
                      <div className={styles.TechCabMarBott}>
                        <div className={`${styles.displayFlexReverseCourseFinder} ${styles.marginBottomCf} ${styles.displayFlex}`}>
                          <div className={styles.childFlex}>
                            <div className={styles.CourseFinderContent}>
                              {/* mobile img */}
                              <div className='d-block d-sm-none'>
                                <div className={styles.platformDivImg}>
                                  <CustomImage
                                    src={
                                      props?.pageData?.courseFinder[0].imagePath
                                    }
                                    alt={
                                      props?.pageData?.courseFinder[0]
                                        .imageAltTag
                                    }
                                    width={333.98}
                                    height={279.13}
                                  />
                                </div>
                              </div>
                              <h3>{props?.pageData?.courseFinder[0].title}</h3>
                              <p>
                                {props?.pageData?.courseFinder[0].description}
                              </p>
                              <ul className='pl-0'>
                                {props?.pageData?.courseFinder[0].points.map(
                                  (point: any) => (
                                    <li>
                                      <h6>{point.title}</h6>
                                      <span>{point.description}</span>
                                    </li>
                                  )
                                )}
                              </ul>
                              <Link href='https://www.coursefinder.ai'>
                                <a target='_blank' className={styles.viewMore}>
                                  Go to coursefinder.ai
                                </a>
                              </Link>
                            </div>
                          </div>
                          <div className={styles.childFlex}>
                            {/* desktop img */}
                            <div className=' d-none d-sm-block'>
                              <div className={styles.platformDivImg}>
                                <CustomImage
                                  src={
                                    props?.pageData?.courseFinder[0].imagePath
                                  }
                                  alt={
                                    props?.pageData?.courseFinder[0].imageAltTag
                                  }
                                  width={579}
                                  height={547}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                    <div className={styles.CourseFinder}>
                      <div className={styles.TechCabMarBott}>
                        <div className={styles.displayFlex}>
                            <div className={styles.childFlex}>
                              {/* desktop img */}
                              <div className='d-none d-sm-block'>
                                <div className={`${styles.platformDivImg} ${styles.ipadImgMb}`} >
                                  <CustomImage
                                    src={props?.pageData?.elanLoans[0].imagePath}
                                    alt={
                                      props?.pageData?.elanLoans[0].imageAltTag
                                    }
                                    width={579}
                                    height={547}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className={styles.childFlex}>
                              <div className={styles.CourseFinderContent}>
                                {/* mobile img */}
                                <div className='d-block d-sm-none'>
                                  <div className={`${styles.platformDivImg} ${styles.monbileImgMb}`}>
                                    <CustomImage
                                      src={
                                        props?.pageData?.elanLoans[0].imagePath
                                      }
                                      alt={
                                        props?.pageData?.elanLoans[0].imageAltTag
                                      }
                                      width={333.98}
                                      height={279.13}
                                    />
                                  </div>
                                </div>
                                <h2>{props?.pageData?.elanLoans[0].title}</h2>
                                <p>{props?.pageData?.elanLoans[0].description}</p>
                                <ul className='pl-0'>
                                  {props?.pageData?.elanLoans[0].points.map(
                                    (point: any) => (
                                      <li>
                                        <h6>{point.title}</h6>
                                        <span>{point.description}</span>
                                      </li>
                                    )
                                  )}
                                </ul>
                                <Link href='https://www.elanloans.com/'>
                                  <a target='_blank' className={styles.viewMore}>
                                  Go to Elan Loans
                                  </a>
                                </Link>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
              </Row>
          </div>
        </Container>
      </div>

      {/*Empowering You & A Team that Understands your Needs */}
      <div className={styles.TechCap}>
        <div className={styles.TechCabMarBott}>
          <Container>
            <div className={styles.customContainer}>
                <Row className='text-center'><h2>Your Business is our Top Priority</h2></Row>
                <div className={`${styles.topPriority} ${styles.displayFlex}`}>
                    <div className={styles.childFlex}>
                      {/* mobile img */}
                      <div className='d-block d-sm-none'>
                          <div
                            className={`${styles.platformDivImg} ${styles.platformDivImgMobile}`}
                          >
                            <CustomImage
                             src={props?.pageData?.topPriority?.imagePath}
                             alt={props?.pageData?.topPriority?.imageAltTag}
                              width={333}
                              height={279}
                            />
                          </div>
                        </div>
                         {/* desktop img */}
                         <div className=' d-none d-sm-block'>
                            <div className={`${styles.commission} ${styles.ipadImgMb}`}>
                              <CustomImage
                                src={props?.pageData?.topPriority?.imagePath}
                                alt={props?.pageData?.topPriority?.imageAltTag}
                                width={579}
                                height={547}
                              />
                            </div>
                         </div>
                    </div>
                    <div className={styles.childFlex}>
                      <div className={styles.commissionsContent}>
                        <h3 className={styles.subHeadStyle}>
                          {props?.pageData?.topPriority?.title}
                        </h3>
                        <p className={styles.subHeadParat}>
                          {props?.pageData?.topPriority?.description}
                        </p>
                        <ul className='pl-0'>
                          {props?.pageData?.topPriority?.points?.length > 0 &&
                            props?.pageData?.topPriority?.points.map(
                              (point: any, index: number) => {
                                return (
                                  <li key={index} className={styles.subHeadUlLi}>
                                    <h6>{point.title}</h6>
                                    <span>{point.description}</span>
                                  </li>
                                );
                              }
                            )}
                        </ul>
                      </div>
                    </div>
                </div>
                <div className={`${styles.empoweringYoumb} ${styles.displayFlexReverse} ${styles.displayFlex}`}>
                    <div className={styles.childFlex}>
                      <div className={styles.EmpoweringYou}>
                        {/* mobile img */}
                        <div className='d-block d-sm-none'>
                          <div
                            className={`${styles.platformDivImg} ${styles.platformDivImgMobile}`}
                          >
                            <CustomImage
                              src={props?.pageData?.EmpoweringYou?.imagePath}
                              alt={props?.pageData?.EmpoweringYou?.imagePathAltTag}
                              width={333}
                              height={279}
                            />
                          </div>
                        </div>
                        <div className={styles.EmpoweringYouContent}>
                          <h3 className='mb-4'>
                            {props?.pageData?.EmpoweringYou?.title}
                          </h3>
                          <p>{props?.pageData?.EmpoweringYou?.description}</p>
                          <ul className='pl-0'>
                            {props?.pageData?.EmpoweringYou.points.map(
                              (point: any) => (
                                <li>
                                  <h6>{point.title}</h6>
                                  <span>{point.description}</span>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className={styles.childFlex}>
                      {/* desktop img */}
                      <div className=' d-none d-sm-block'>
                        <div className={`${styles.platformDivImg} ${styles.ipadImgMb}`}>
                          <CustomImage
                            src={props?.pageData?.EmpoweringYou?.imagePath}
                            alt={props?.pageData?.EmpoweringYou?.imagePathAltTag}
                            width={579}
                            height={547}
                          />
                        </div>
                      </div>
                    </div>
                </div>
            </div>
          </Container>
        </div>
        <div className={styles.TechCabMarBott}>
          <Container>
            <div className={styles.displayFlex}>
              <div className={styles.childFlex}>
                {/* desktop img */}
                <div className=' d-none d-sm-block'>
                  <div className={`${styles.platformDivImg} ${styles.ipadImgMb}`}>
                    <CustomImage
                      src={
                        props?.pageData?.AteamYourUnderstandsYourNeeds
                          ?.imagePath
                      }
                      alt={props?.pageData?.AteamYourUnderstandsYourNeeds?.alt}
                      width={579}
                      height={547}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.childFlex}>
                <div className={styles.EmpoweringYou}>
                  {/* mobile img */}
                  <div className='d-block d-sm-none'>
                    <div className={styles.platformDivImg}>
                      <CustomImage
                        src={
                          props?.pageData?.AteamYourUnderstandsYourNeeds
                            ?.imagePath
                        }
                        alt={
                          props?.pageData?.AteamYourUnderstandsYourNeeds?.alt
                        }
                        width={333}
                        height={279}
                      />
                    </div>
                  </div>
                  <div className={styles.EmpoweringYouContent}>
                    <h3> {props?.pageData?.AteamYourUnderstandsYourNeeds?.title} </h3>
                    <p>
                      {
                        props?.pageData?.AteamYourUnderstandsYourNeeds
                          ?.description
                      }
                    </p>
                    <ul className='pl-0'>
                      <li>
                        <h6>End-to-End Assistance</h6>
                        <span>
                          Comprehensive assistance for applications, financials,
                          verifications, interviews & visas
                        </span>
                      </li>
                      <li>
                        <h6>Regional Managers</h6>
                        <span>
                          A team of industry professionals is ready to support
                          you instantly with any of your queries
                        </span>
                      </li>
                      <li>
                        <h6>Multiple channels of communication</h6>
                        <span>
                          Emails, WhatsApp Chats, Calls, or Comments in the
                          coursefinder.ai - Reach us through your preferred
                          communication channel, as we are always listening.
                        </span>
                      </li>
                    </ul>
                    
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>

      <div className={styles.ThreeSteps}>
        <Container>
          <div>
            <div className={styles.studentFooter}>
              <Container>
                <div className={styles.session}>
                  <Row>
                    <Col lg={7}>
                      <div className={styles.text}>
                        <h3>
                          Partner with us to drive your business faster & reach
                          your goals sooner
                        </h3>
                      </div>
                    </Col>
                    <Col lg={5}>
                      <div className={styles.anchor}>
                        <a
                          className={`${styles.reqCall
                            } ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[1]?.jotformid)}`}
                        >
                          Enquire Now
                        </a>
                        <a
                          className={`${styles.partnerBtn} ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0]?.jotformid)}`}
                        >
                          Partner With Us
                        </a>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <div className={styles.customContainer}>
         <CfAppBanner />
      </div>
      
       {/* Top 8 Tie Ups of KC in World’s Top 350 */}
       <div className={styles.partnerUniTie}>
        <TopTieUpsOfKC />
      </div>
  
        <Testimonial
          title='Our partners love us'
          bgColor='#ffffff'
          slug={`testimonials?type=partner&_limit=15&_sort=id:DESC`}
        />
     
      <div className={styles.achievements}>
        {props.pageData?.videoTestimonial &&
          <VideoTestimonials {...props.pageData.videoTestimonial} />}
       </div>

      {/* Webinars & Events */}
      <div className={styles.partnerWebinarEvent}>
        <FeaturedPartnerWebinars title={'Webinars for Partners'} />
      </div>

      <div className={styles.partnerRecognitions}>
        <Recognition bgColor={'#B8AAEE'} />
      </div>

      <div className={styles.partnerKcUpdates}>
        <KcNewLatestUpdates {...props} />
      </div>

      <div className={styles.partnerBlogs}>
        <FeaturedBlogs />
      </div>

      {props.pageData?.faq &&
        <FaqComponent {...props.pageData.faq} />}
    </div>
  );
};

export default ServicesForPartnerPage;
